import { FAIcon, Theme, SearchDataStructure, AttributeTypes, TagStyle, Tag } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';

type IRewardBO = {
  [key: string]: DynamicObjectInterface;
};

const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Reward Code',
    key: 'rewardCode',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Reward Name',
    key: 'rewardName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  // {
  //   name: 'Enrollment Type',
  //   key: 'enrollmentType',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: true,
  //   dataset: [
  //     {
  //       key: 'participant',
  //       value: 'PARTICIPANT',
  //     },
  //     {
  //       key: 'coach',
  //       value: 'COACH',
  //     },
  //     {
  //       key: 'leader',
  //       value: 'LEADER',
  //     },
  //   ],
  // },
];

const getRewardListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'rewardCode',
    text: translation('admin.rewardMaster.rewardCode'),
    sortable: true,
    width: 10,
    render: (object: IRewardBO) => <span>{object.rewardCode}</span>,
  },
  {
    key: 'rewardName',
    text: translation('admin.rewardMaster.rewardName'),
    sortable: true,
    width: 14,
    render: (object: IRewardBO) => <span>{object.rewardName}</span>,
  },
  // {
  //   key: 'enrollmentType',
  //   text: translation('admin.rewardMaster.enrollmentType'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: IRewardBO) => <span>{object.enrollmentType}</span>,
  // },
  {
    key: 'status',
    text: translation('admin.rewardMaster.status'),
    sortable: true,
    width: 5,
    render: (object: IRewardBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'action',
    width: 5,
    text: 'Actions',
    render: (object: IRewardBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onClick(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getRewardListConfig;
export { dataSearchOption };
